import { Progress as RadixProgress, ProgressProps } from '../radix-ui/progress';

export function Progress({ value, ...props }: ProgressProps) {
  return (
    <RadixProgress.Root value={value} {...props}>
      <RadixProgress.Indicator type={props.type} value={value} />
    </RadixProgress.Root>
  );
}
